"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.getAllPageTranslations = exports.getPageTranslations = exports.getPageChildren = exports.getPage = void 0;
var client_1 = require("../api/client");
var wagtailConfig_1 = require("../config/wagtailConfig");
exports.getPage = function (id) {
    var url = "" + wagtailConfig_1.ADMIN_API.PAGES + id + "/";
    return client_1.get(url);
};
exports.getPageChildren = function (id, options) {
    if (options === void 0) { options = {}; }
    var url = wagtailConfig_1.ADMIN_API.PAGES + "?child_of=" + id + "&for_explorer=1";
    if (options.fields) {
        url += "&fields=parent," + window.encodeURIComponent(options.fields.join(','));
    }
    else {
        url += '&fields=parent';
    }
    if (options.onlyWithChildren) {
        url += '&has_children=1';
    }
    if (options.offset) {
        url += "&offset=" + options.offset;
    }
    url += wagtailConfig_1.ADMIN_API.EXTRA_CHILDREN_PARAMETERS;
    return client_1.get(url);
};
exports.getPageTranslations = function (id, options) {
    if (options === void 0) { options = {}; }
    var url = wagtailConfig_1.ADMIN_API.PAGES + "?translation_of=" + id + "&limit=20";
    if (options.fields) {
        url += "&fields=parent," + global.encodeURIComponent(options.fields.join(','));
    }
    else {
        url += '&fields=parent';
    }
    if (options.onlyWithChildren) {
        url += '&has_children=1';
    }
    if (options.offset) {
        url += "&offset=" + options.offset;
    }
    return client_1.get(url);
};
exports.getAllPageTranslations = function (id, options) { return __awaiter(void 0, void 0, void 0, function () {
    var items, iterLimit, page;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                items = [];
                iterLimit = 100;
                _a.label = 1;
            case 1: return [4 /*yield*/, exports.getPageTranslations(id, __assign({ offset: items.length }, options))];
            case 2:
                page = _a.sent();
                page.items.forEach(function (item) { return items.push(item); });
                if (items.length >= page.meta.total_count || iterLimit-- <= 0) {
                    return [2 /*return*/, items];
                }
                _a.label = 3;
            case 3: return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}); };
